export const DEFAULT_TOOL_CONFIG = {
  dalle: {
    autoGenerate: false,
  },
};
